import { Link } from 'react-router-dom';

/**
 * Consistent page title row used at the top of every dashboard page.
 * Optionally renders a right-side action slot (button, search, etc.).
 */
const PageHeader = ({ title, subtitle, action, breadcrumbs }) => (
  <div className="mb-5 sm:mb-6 flex flex-wrap items-end justify-between gap-3">
    <div className="min-w-0">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-1.5 text-xs text-ink-500 dark:text-ink-400 mb-1.5">
          {breadcrumbs.map((b, i) => (
            <span key={i} className="flex items-center gap-1.5">
              {i > 0 && <span>›</span>}
              {b.to ? (
                <Link to={b.to} className="hover:text-ink-700 dark:hover:text-ink-200 transition-colors">{b.label}</Link>
              ) : (
                <span>{b.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      <h1 className="text-xl sm:text-2xl font-bold text-ink-900 dark:text-white tracking-tight truncate">{title}</h1>
      {subtitle && (
        <p className="text-sm text-ink-500 dark:text-ink-400 mt-1 truncate">{subtitle}</p>
      )}
    </div>
    {action && <div className="flex items-center gap-2 flex-shrink-0">{action}</div>}
  </div>
);

export default PageHeader;
